import { render } from "./TermsModal.vue?vue&type=template&id=0743aaae&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"

import "./TermsModal.vue?vue&type=style&index=0&id=0743aaae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0743aaae"]])

export default __exports__